import {
  OfferFormData,
  PaymentMethods,
} from '@features/offers/interfaces/offersInterface';
import { RadioController } from '@organisms';
import {
  Checkbox,
  CheckboxOptionType,
  Col,
  Flex,
  Form,
  Row,
  Typography,
} from 'antd';
import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';

import { toFieldStatus } from 'src/app/utils/toFieldStatus';

interface FormPaymentOptionsProps {
  control: Control<OfferFormData>;
}

const paymentMethodsOptions: CheckboxOptionType<PaymentMethods>[] = [
  { label: 'Cartão de crédito', value: 'creditCard' },
  { label: 'Nupay', value: 'nupay' },
  { label: 'Pagaleve', value: 'pagaleve' },
  { label: 'Pix', value: 'pix' },
  { label: 'Boleto', value: 'billet' },
];

export const PaymentOptions: FC<FormPaymentOptionsProps> = ({
  control,
}: FormPaymentOptionsProps) => {
  const { Text } = Typography;

  return (
    <Flex style={{ width: '100%', gap: '56px' }}>
      <Col>
        <Row>
          <Text
            style={{
              fontSize: '14px',
              lineHeight: '22px',
            }}
          >
            Opções iniciais de pagamento
          </Text>
        </Row>
        <Row style={{ alignItems: 'center', gap: '24px' }}>
          <Controller
            control={control}
            name='sensitiveData.paymentMethods'
            render={({ field, fieldState }) => {
              const { status, help } = toFieldStatus(fieldState.error);
              return (
                <Form.Item
                  style={{ marginBottom: 0 }}
                  validateStatus={status}
                  help={help}
                  required
                >
                  <Checkbox.Group
                    options={paymentMethodsOptions}
                    {...field}
                    value={field.value}
                    onChange={field.onChange}
                  />
                </Form.Item>
              );
            }}
          />
        </Row>
      </Col>
      <Col>
        <Row>
          <Col>
            <Text
              style={{
                width: '100%',
                lineHeight: '28px',
              }}
            >
              Exibir cupom?
            </Text>
            <RadioController
              control={control}
              name='sensitiveData.isDisplayCoupon'
              options={[
                { label: 'Sim', value: true },
                { label: 'Não', value: false },
              ]}
            />
          </Col>
        </Row>
      </Col>
    </Flex>
  );
};
